"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var InputSizesCSS_1 = require("./InputSizesCSS");

var InputStatesCSS_1 = require("./InputStatesCSS");

var theme_1 = require("../theme");

exports.Textarea = styled_components_1.default.textarea(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  outline: none;\n  padding: 0.8em 1em;\n  font-size: 0.9em;\n  border: 1px solid ", ";\n  border-bottom: 2px solid ", ";\n  border-radius: 4px;\n  &::placeholder {\n    color: ", ";\n  }\n  ", "\n  ", "\n"])), function (props) {
  return props.width || "100%";
}, theme_1.theme.colors.white[300], theme_1.theme.colors.white[300], theme_1.theme.colors.gray[900], InputStatesCSS_1.InputStatesCSS, InputSizesCSS_1.InputSizesCSS);